const PRODUCT_LINKED_CLASS = '.js-product-linked-item'
const PRODUCT_LINKED_ACTIVE_CLASS = 'product-linked__item--active'
const PRODUCT_ITEM_CLASS = '.js-product-item'
const PRODUCT_VARIANT_CLASS = '.js-product-variant'
const PRODUCT_FORM_CLASS = '.js-product-item-form'
const PRODUCT_FORM_INPUT_CLASS = '.js-product-form-input'
const PRODUCT_FORM_BUTTON_CLASS = '.js-product-form-button'
const PRODUCT_LINKED_SELECTOR = '.product-linked'
const PRODUCT_LINKED_CONTENT_SELECTOR = '.js-product-linked-content'

const parents = (el, selector) => {
  while ((el = el.parentNode) && el !== document) {
    if (!selector || el.matches(selector)) {
      return el
    }
  }
}

const getButtonTrigger = (element) => {
  const productLinkedItems = element ? element.querySelectorAll(PRODUCT_LINKED_CLASS) : document.querySelectorAll(PRODUCT_LINKED_CLASS)
  const viewModeLayout = window.location.search === '?view=list' ? 'list' : 'grid'
  if (productLinkedItems.length > 0) {
    productLinkedItems.forEach((item) => {
      item.addEventListener('click', (e) => {
        e.preventDefault()
        if (!e.target.classList.contains(PRODUCT_LINKED_ACTIVE_CLASS)) {
          fetchProductData(e.target.href + `?view=${viewModeLayout}`, parents(e.target, PRODUCT_ITEM_CLASS))
          prepareQuickAdd()
        }
      })
    })
  }
  addToCart()
}

const prepareQuickView = (id) => {
  var event = new CustomEvent('prepare-quick-view', {
    detail: {
      selector: `.quickview-button #${id}`
    }
  })
  document.dispatchEvent(event)
}

const prepareQuickAdd = () => {
  document.dispatchEvent(new CustomEvent('prepare-quick-add', {
    bubbles: true
  }))
}

const activeQuickView = (parent) => {
  const quickViewButton = parent.querySelector('.quickview-button a')
  if (quickViewButton) {
    quickViewButton.addEventListener('click', () => {
      prepareQuickView(quickViewButton.id)
    })
  }
}

const fetchProductData = async (endpoint, element) => {
  await fetch(endpoint)
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser()
      const fetchedDocument = parser.parseFromString(html, 'text/html')
      const productItemInner = fetchedDocument.querySelector(PRODUCT_ITEM_CLASS).innerHTML

      if (productItemInner) {
        element.innerHTML = productItemInner
      }
    })
  getButtonTrigger(element)
  activeQuickView(element)
}

const addToCart = () => {
  const productVariantItems = document.querySelectorAll(PRODUCT_VARIANT_CLASS)

  productVariantItems.forEach(item => {
    item.addEventListener('click', (e) => {
      e.preventDefault()
      const productFormEl = parents(e.target, PRODUCT_FORM_CLASS)
      const productFormInputEl = productFormEl.querySelector(PRODUCT_FORM_INPUT_CLASS)
      const productFormButtonEl = productFormEl.querySelector(PRODUCT_FORM_BUTTON_CLASS)

      productFormInputEl.value = e.target.dataset.variant
      productFormButtonEl.click()
    })
  })
}

const fetchLinkedData = async (endpoint, element) => {
  await fetch(endpoint)
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser()
      const fetchedDocument = parser.parseFromString(html, 'text/html')
      const productLinkedContent = fetchedDocument.querySelector(PRODUCT_LINKED_CONTENT_SELECTOR)
      element.appendChild(productLinkedContent)
    })
  getButtonTrigger(element)
}

const buildColorSwatches = () => {
  const productItems = document.querySelectorAll(PRODUCT_ITEM_CLASS)
  productItems.forEach(item => {
    fetchLinkedData(item.dataset.productLinked, item.querySelector(PRODUCT_LINKED_SELECTOR))
  })
}

(function () {
  const pushState = history.pushState
  const replaceState = history.replaceState

  history.pushState = function () {
    pushState.apply(history, arguments)
    window.dispatchEvent(new Event('pushstate'))
    window.dispatchEvent(new Event('locationchange'))
  }

  history.replaceState = function () {
    replaceState.apply(history, arguments)
    window.dispatchEvent(new Event('replacestate'))
    window.dispatchEvent(new Event('locationchange'))
  }

  window.addEventListener('popstate', function () {
    window.dispatchEvent(new Event('locationchange'))
  })
})()

window.addEventListener('locationchange', function (){
  setTimeout(() => {
    buildColorSwatches()
    getButtonTrigger()
  }, 2000)
})

buildColorSwatches()
getButtonTrigger()
